import {createRoot, hydrateRoot} from 'react-dom/client';
import GetAQuote from '../pages/GetAQuote/GetAQuote'
import "../index.css";
import "../pages/GetAQuote/GetAQuote.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<GetAQuote {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <GetAQuote {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).GetAQuoteVC = {mount, hydrate, unmount}